import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../constant/TYPE";
import { clearLoadingAction } from "../../../redux/loading";
import GrammarViewer from "../../common/grammarViewer/GrammarViewer";

const deviceType = [
  TYPE.DEVICE.PAD,
  '',
  TYPE.DEVICE.PHONE,
  TYPE.DEVICE.PC
];

const Grammar = ( props ) => {

  const [ viewRatio, setViewRatio ] = useState( 1 );

  const pvCont = useRef();
  const deviceInfo = useSelector( state => state.deviceInfo );

  const dispatch = useDispatch();
  const clearLoading = () => { dispatch( clearLoadingAction() ) };

  useEffect( () => {
    if ( deviceInfo.type && props.data.fontSize ) {
      const deviceScale = TYPE.DEVICE.PHONE === deviceInfo.type ? 1.5 : 2;
      const userScale = props.data.fontSize.split( ';' ).map( v => parseInt( v ) );
      const userScaleIndex = deviceType.map( ( v, i ) => deviceInfo.type === v ? i : NaN ).filter( v => ! isNaN( v ) )[ 0 ];
      
      setViewRatio( deviceScale * userScale[ userScaleIndex ] / 100 );
      
    }
  }, [ deviceInfo.type, props.data.fontSize ] );
  
  const renderMathJax = () => {
    setTimeout( () => {
      document.getElementById('pv-inner-grammar').style.width = `${pvCont.current.offsetWidth * viewRatio}px`;
      document.getElementById('pv-inner-grammar').style.height = `${pvCont.current.offsetHeight * viewRatio}px`;
      clearLoading();
    } );
  };

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('pv-inner-grammar').style.width = `${pvCont.current.offsetWidth * viewRatio}px`;
      document.getElementById('pv-inner-grammar').style.height = `${pvCont.current.offsetHeight * viewRatio}px`;
    }, 10)
  }, [props.children])



  return (
    <div className="pvBox" style={ { padding : 40 } }>
      <div 
        className="pv-inner" 
        id="pv-inner-grammar"
      >
        <div className="pv-cont" style={{ transform: `scale(${viewRatio})` }} ref={pvCont}>
          <GrammarViewer type={ TYPE.MATHJAX.CHECK_WRONG_ANSWER } onRender={ renderMathJax }>{ props.children }</GrammarViewer>
        </div>
      </div>
    </div>
  );

};

Grammar.defaultProps = {
  data : {}
};

export default Grammar;
